<div class="form-group" [hidden]="!showUploadButton">
    <input #input type="file" (change)="UploadFiles()" id="input" class="form-control" 
        [accept]="supportedTypes" /><br />
</div>

<div class="upload-progress" *ngIf="showProgressIndicator && uploadInProgress">
    <span class="upload-progress-spinner"></span>
    <span class="upload-progress-text">Upload in Progress ...</span>
</div>